import { render, staticRenderFns } from "./IconBuffering.vue?vue&type=template&id=05dabe2a&scoped=true&"
import script from "./IconBuffering.vue?vue&type=script&lang=js&"
export * from "./IconBuffering.vue?vue&type=script&lang=js&"
import style0 from "./IconBuffering.vue?vue&type=style&index=0&id=05dabe2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dabe2a",
  null
  
)

export default component.exports